import {get} from "./request";

export const clientApi = {};

clientApi.getOne = async ({id}) => {
  try {
    const {data} = await get(`/client/one/${id}`);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
